module.exports = "/_next/static/images/mona-lisa-6d59cbbd3c13e7402cd4ac0fa86923ad.png";